export default __webpack_public_path__ + "static/media/element_33.e47de264.avif";